'use client';
import { useRef, useState, useEffect, useLayoutEffect } from 'react';

function useColorSwatchesLayout(total, explicitExtra) {
  const containerRef = useRef(null);
  const sampleSwatchRef = useRef(null);
  const hiddenPlusRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(total);
  const [computedExtra, setComputedExtra] = useState(0);
  useEffect(() => {
    if (explicitExtra !== void 0) {
      setVisibleCount(total);
      setComputedExtra(Number(explicitExtra) || 0);
    }
  }, [explicitExtra, total]);
  useLayoutEffect(() => {
    if (explicitExtra !== void 0) return;
    const el = containerRef.current;
    const sw = sampleSwatchRef.current;
    const plus = hiddenPlusRef.current;
    if (!el || !sw || !plus || total === 0) return;
    const compute = () => {
      const cw = el.getBoundingClientRect().width;
      if (!cw) return;
      const cs = getComputedStyle(el);
      const gapX = parseFloat(cs.columnGap || cs.gap || "5") || 5;
      const iw = sw.getBoundingClientRect().width;
      if (!iw) return;
      let n = Math.min(total, Math.floor((cw + gapX) / (iw + gapX)));
      if (n <= 0) n = 1;
      if (n >= total) {
        setVisibleCount(total);
        setComputedExtra(0);
        return;
      }
      const remainingBase = total - n;
      plus.textContent = `+${remainingBase}`;
      const plusW = plus.getBoundingClientRect().width || 0;
      const used = n * iw + (n - 1) * gapX;
      let rem = cw - used;
      const needed = (n > 0 ? gapX : 0) + plusW;
      while (n > 0 && rem < needed) {
        n -= 1;
        const used2 = n * iw + (n - 1) * gapX;
        rem = cw - used2;
      }
      const extra = Math.max(total - n, 0);
      setVisibleCount(n);
      setComputedExtra(extra);
    };
    compute();
    const ro = new ResizeObserver(() => compute());
    ro.observe(el);
    return () => ro.disconnect();
  }, [explicitExtra, total]);
  return {
    containerRef,
    sampleSwatchRef,
    hiddenPlusRef,
    visibleCount,
    computedExtra
  };
}

export { useColorSwatchesLayout };
